export function rearrangeDayLabels(
  dayLabels: Array<string>,
  firstDayOfWeek?: number,
): Array<string> {
  const cloneDefaultDayLabels = [...dayLabels];

  if (firstDayOfWeek !== undefined && firstDayOfWeek === 7) {
    // Fri and Sat weekends
    // Do nothing because [enShortDayLabels] is already in that sequence.
  } else if (firstDayOfWeek !== undefined && firstDayOfWeek === 6) {
    // Thur and Fri weekends
    cloneDefaultDayLabels.unshift(cloneDefaultDayLabels.pop() || '');
  } else {
    // Sat and Sun weekends
    cloneDefaultDayLabels.push(cloneDefaultDayLabels.shift() || '');
  }
  return cloneDefaultDayLabels;
}

/**
 * Converts 12-hour format time string to 24-hour format
 * @param time12h - Time string in 12-hour format (e.g., "02:00 PM", "12:00 AM")
 * @returns Time string in 24-hour format (e.g., "14:00:00", "00:00:00")
 */
export const convertTo24HourFormat = (time12h: string): string => {
  const [time, modifier] = time12h.split(' ');
  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = (parseInt(hours, 10) + 12).toString();
  }

  return `${hours.padStart(2, '0')}:${minutes}:00`;
};
